import { Component, OnInit, OnDestroy } from '@angular/core';
import { Router } from '@angular/router';
import { Subject } from 'rxjs';
import { debounceTime, distinctUntilChanged } from 'rxjs/operators';
import { BondsServices } from 'src/app/services/bonds.service';
import { fixedPassFromLabel, isFixedPricePass } from 'src/app/utils/fixed-price-pass.util';

@Component({
  selector: 'app-passes-list',
  templateUrl: './passes-list.component.html',
  styleUrls: ['./passes-list.component.scss']
})
export class PassesListComponent implements OnInit, OnDestroy {

  passes: any[] = [];
  loaded: boolean = false;
  searchText: string = '';
  discountTypeFilter: string = '';
  private searchTerms = new Subject<string>();

  constructor(private bondsService: BondsServices, private router: Router) { }

  ngOnInit(): void {
    this.loadPasses();
    this.searchTerms.pipe(
      debounceTime(400),
      distinctUntilChanged()
    ).subscribe(term => {
      this.searchText = term;
      this.loadPasses();
    });
  }

  loadPasses() {
    this.loaded = false;
    const filters: any = { active: true };
    if (this.searchText) filters.search = this.searchText;
    if (this.discountTypeFilter) filters.discount_mode = this.discountTypeFilter;

    this.bondsService.getPublicPasses(filters).subscribe({
      next: (res) => {
        this.passes = res?.discounts || res?.data || [];
        this.loaded = true;
      },
      error: () => {
        this.passes = [];
        this.loaded = true;
      }
    });
  }

  onSearch(term: string) {
    this.searchTerms.next(term);
  }

  onFilterChange() {
    this.loadPasses();
  }

  getDiscountLabel(pass: any): string {
    if (isFixedPricePass(pass)) {
      return fixedPassFromLabel(pass);
    }
    if (pass.discount_mode === 'percentage') {
      return `${Math.trunc(pass.discount_value)}% de descuento`;
    }
    return `${pass.discount_value}€ de descuento`;
  }

  getEventCount(pass: any): number {
    if (pass.pass_items?.length) return pass.pass_items.length;
    if (pass.min_events) return pass.min_events;
    return 0;
  }

  openPass(pass: any) {
    this.router.navigate(['/abonos', pass.id]);
  }

  ngOnDestroy(): void {
    this.searchTerms.complete();
  }
}
